var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.257 8.75V8.09546C17.257 7.65909 16.9613 7.36818 16.5178 7.36818C16.0744 7.36818 15.7787 7.65909 15.7787 8.09546V8.75C15.7787 12.3864 12.8222 15.2955 9.12653 15.2955C5.43088 15.2955 2.47435 12.3864 2.47435 8.75C2.47435 5.11364 5.43088 2.20455 9.12653 2.20455C10.0874 2.20455 10.9744 2.42273 11.8613 2.78636C12.2309 2.93182 12.6744 2.78636 12.8222 2.42273C12.97 2.05909 12.8222 1.62273 12.4526 1.47727C11.4178 0.968182 10.2352 0.75 9.12653 0.75C4.61783 0.75 0.996094 4.31364 0.996094 8.75C0.996094 13.1864 4.61783 16.75 9.12653 16.75C13.6352 16.75 17.257 13.1864 17.257 8.75ZM16.7396 1.69545C17.0352 1.40455 17.4787 1.40455 17.7744 1.69545C18.07 1.98636 18.07 2.42273 17.7744 2.71364L9.64392 10.7136C9.49609 10.8591 9.27435 10.9318 9.12653 10.9318C8.9787 10.9318 8.75696 10.8591 8.60914 10.7136L6.39175 8.53182C6.09609 8.24091 6.09609 7.80455 6.39175 7.51364C6.6874 7.22273 7.13088 7.22273 7.42653 7.51364L9.12653 9.18636L16.7396 1.69545Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWhite);
export default __webpack_public_path__ + "static/media/checkCircleWhite.ba7b5c059810cafdac4a551119f66760.svg";
export { ForwardRef as ReactComponent };